<!-- Base directory containing all cities -->
<template>
  <div class="uk-container">

    <h2>Welcome to the directory!</h2>
    <h4>Choose your city</h4>

    <a class="uk-text-large uk-padding uk-button uk-button-primary" :href="getCityDirectoryPage('oakland')">Oakland Directory</a>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { getCityDirectoryPage } from '@/router/route_utils';

export default defineComponent({
  name: 'DirectoryBasePage',
  components: {
  },
  data() {
    return {
      loading: [],
    };
  },
  methods: {
    getCityDirectoryPage,
  },
  apollo: {
  },
});
</script>
